import Vue from "vue";
import router from "./router";
import accounting from "accounting";
import App from "./App";
import store from "./store";
import layout from "./components/shared/layout.vue";
import FullLayout from "./components/shared/FullLayout.vue";
import mobileLayout from "./components/shared/mobileLayout.vue";
import VeeValidate from "vee-validate";
import { Validator } from "vee-validate";
import { ValidationProvider } from "vee-validate";
import { veeCustomMessage } from "./validation/dictionary";
import { DetectMobile } from "./mixins/detectmobile";
import { DetectWC } from "./mixins/wcDetector";
import { DetectVersion } from "./mixins/versionDetector";
import { DetectBrand } from "./mixins/brandDetector";
import { formatCard } from "./filters/formatCard";
import { urlify } from "./filters/urlify";
import { camelCase } from "./filters/camelCase";
import { truncateText } from "./filters/truncateText";
import VueLazyload from "vue-lazyload";
import { logger } from "./api/Logger.js";
import { veeCustomValidator } from "./validation/GeneralValidators";
import VueQrcodeReader from "vue-qrcode-reader";
import VueI18n from "vue-i18n";
import messages from "../lang/locale.json";
import { inputNameLocale } from "./filters/inputNameLocale";
import { customValidations } from "./validation/validationHelper";
import { Bugfender } from '@bugfender/sdk';
import { StripePlugin } from '@vue-stripe/vue-stripe';
export const bus = new Vue();
import { BootstrapVue } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(BootstrapVue)


customValidations(Validator);
import { AppConfig } from "./../AppConfig";
import EventBus from "./event-bus";
Vue.use(VueQrcodeReader);
Vue.use(VueI18n);
Vue.use(VueLazyload);
const stripeKey = store.getters.getStripeKey;
Vue.use(StripePlugin, {
  pk: stripeKey
})
Vue.mixin(DetectMobile);
Vue.mixin(DetectWC);
Vue.mixin(DetectBrand);
Vue.mixin(DetectVersion);
Vue.use(VeeValidate, {
  dictionary: veeCustomMessage,
  errorBagName: "OOErrors",
  mode: "lazy",
});
Bugfender.init({
  appKey: 'aJgMuctkrEEABvVH2EYZEfZdmDDWqbbI',
});

veeCustomValidator.init(VeeValidate);
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("default-layout", layout);
Vue.component("full-layout", FullLayout);
Vue.component("mobile-layout", mobileLayout);
require("./assets/bootstrap/scss/bootstrap.scss");
require("./assets/main.scss");
require("./assets/main.mobile.scss");
require("jquery");
require("popper.js");
require("bootstrap");
Vue.config.productionTip = false;

Vue.filter("truncateText", truncateText);
Vue.filter("formatMoney", accounting.formatMoney);
Vue.filter("formatCard", formatCard);
Vue.filter("urlify", urlify);
Vue.filter("inputNameLocale", inputNameLocale);
Vue.filter("camelCase", camelCase);
Vue.filter("formatNumber", function(value) {
  return new Intl.NumberFormat().format(value);
});
if (process.env.NODE_ENV === "production") {
  Vue.config.errorHandler = function(err, vm, info) {
    let handler,
      current = vm;
    logger.log(info, err.message, vm.$vnode.tag, logger.LogType.Error);
    if (vm.$options.errorHandler) {
      handler = vm.$options.errorHandler;
    } else {
      while (current.$parent) {
        current = current.$parent;
        if ((handler = current.$options.errorHandler)) break;
      }
    }
    if (handler) handler.call(current, err, vm, info);
    // else router.replace({ name: "generalError" });
  };
  Vue.config.warnHandler = function(err, vm, info) {
    let tag = vm && vm.$vnode ? vm.$vnode.tag : "";
    logger.log(info, err, tag, logger.LogType.Warning);
  };
}
var googleApiScript = document.createElement("script");
googleApiScript.setAttribute(
  "src",
  `https://maps.googleapis.com/maps/api/js?key=${
    process.env.NODE_ENV === "production"
      ? AppConfig.googleApiKey
      : "AIzaSyDDAfrPKcVxx096l5SHZvoaWt7d-wrag-8"
  }&libraries=places&callback=initMap`
);
function initMap() {}
window.initMap = initMap;
document.head.appendChild(googleApiScript);

// Create VueI18n instance with options
const i18n = new VueI18n({
  messages, // set locale messages
});
store.commit("setAvailableLocales", i18n.availableLocales);
i18n.locale = store.getters.selectedLocale;
new Vue({
  el: "#shop",
  router: router,
  store,
  i18n,
  mounted() {
    EventBus.$on('update-stripe-config', stripeKey => {
      Vue.use(StripePlugin, {
        pk: stripeKey
      });
    });
  },
  render: (h) => h(App),
});
